export function getEnvironmentFromUrl(url: string): string {
    if (url.indexOf(".theidoluat.") > -1) {
        return "staging";
    } else if (url.indexOf("legalandgeneral.") > -1) {
        return "production";
    }
    return "test";
}
